<template>
  <el-upload
    id="upload"
    action="/api-customer/zuul/dig-construction/uploadFile"
    :headers="{token: $store.state.token}"
    list-type="picture-card"
    :file-list="fileList"
     :on-change="onChange"
    :on-error="onError"
    :on-success="uploadSuccess"
    :on-preview="preview"
    :limit="limit"
    accept="image/*"
    :on-remove="handleRemove"
  >
    <i class="el-icon-plus"></i>
  </el-upload>
</template>

<script>
import { ImagePreview } from "vant";
import { uploadImgAPI } from "@/api/facility";
import { compress } from "@/utils/compress";

export default {
  name: "uploadImg",
  props: {
    fileList: {
      type: Array,
      default: () => []
    },
    limit: {
      type: Number,
      default: 3
    },
    capture: {
      type: Boolean,
      default: false
    }
  },
  model: {
    prop: "fileList",
    event: "fileListChange"
  },
  created() {},
  mounted() {
    this.addCaptureAttr();
  },
  methods: {
    onChange(file, fileList) {
      console.log(file, fileList);
    },
    httpRequest({ file }) {
      const _that = this;
      const isLt10M = file.size / 1024 / 1024 < 10;
      if (!isLt10M) {
        this.$toast("上传图片大小不能超过 10M!");
        return;
      } else {
        compress(file, val => {
          console.log(val);
          const formData = new FormData();
          formData.append("file", val);
          uploadImgAPI(formData)
            .then(res => {
              console.log(res);
              this.uploadSuccess2(res, this.fileList);
            })
            .catch(e => {
              console.log(this.fileList);
              // 失败删除掉
              // this.fileList.forEach((fileItem, index) => {
              //   if (fileItem.url === res.url) {
              //     fileList.splice(index, 1);
              //   }
              // });
              // 失败删除掉
              // this.fileList.splice(-1, 1);
            });
        });
      }
    },
    onError(err, file, fileList){
    },
    // 图片预览
    handlePictureCardPreview(file) {
      console.log(file);
    },
    addCaptureAttr() {
      if (this.capture) {
        let inputFile = document.getElementsByName("file")[0];
        inputFile.setAttribute("capture", "camera");
      }
    },
    handleRemove(file, fileList) {
      console.log('remove')
      let exportRes = this.fileList.filter(
        fileItem => !(fileItem.url === file.url)
      );
      document.querySelector("#upload .el-upload").style.display =
        "inline-block";
      this.$emit("fileListChange", exportRes);
    },
    uploadSuccess2(file, fileList) {
      let exportRes = [];
      exportRes = this.fileList.concat(file);
      if (exportRes.length >= this.limit) {
        document.querySelector("#upload .el-upload").style.display = "none";
      }
      this.$emit("fileListChange", exportRes);
    },
    uploadSuccess(response, file, fileList) {
      console.log(response);
      let exportRes = [];
      if (response.code === 200) {
        exportRes = this.fileList.concat(response.data);
        if (exportRes.length >= this.limit) {
          document.querySelector("#upload .el-upload").style.display = "none";
        }
        this.$emit("fileListChange", exportRes);
      } else {
        // 失败删除掉
        fileList.forEach((fileItem, index) => {
          if (fileItem.url === file.url) {
            fileList.splice(index, 1);
          }
        });
      }
    },
    preview() {
      console.log(this.fileList);
      let images = this.fileList.map(item => item.url);
      ImagePreview({
        images: images
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/base/uploadImg.vue